import { gql } from '@apollo/client';
import BaseService from './baseService';

class DispatchStatusesService extends BaseService {
  constructor() {
    super();
    this.dispatchStatusesGql = `
      statusId
      status
    `;
  }

  getDispatchStatuses = () => new Promise((resolve, reject) => {
    const DISPATCH_STATUSES = gql`
      query {
        dispatchStatuses{
            ${this.dispatchStatusesGql}
        }
      }
    `;

    this.client
      .query({
        fetchPolicy: 'no-cache',
        query: DISPATCH_STATUSES
      })
      .then((result) => {
        if (result.data.dispatchStatuses) {
          resolve(result.data.dispatchStatuses);
        } else {
          reject(result.data.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
        reject(error);
      });
  });
}

const dispatchStatusesService = new DispatchStatusesService();

export default dispatchStatusesService;
